import React from "react";
import { Link } from "react-router-dom";
import BlogCard from "../../components/common/BlogCard/BlogCard";
import MainButton from "../../components/common/MainButton/MainButton";
import Heading from "../../components/common/Typography/Heading";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import {
  PUBLIC_SECTION_GAP_CLASS,
  PUBLIC_HEADING_TO_CONTENT_CLASS,
  PUBLIC_HOME_BLOG_GRID_CLASS,
  PUBLIC_CARD_GRID_GAP_CLASS,
  PUBLIC_IMAGE_TO_HEADING_CLASS,
  PUBLIC_HEADING_TO_BODY_CLASS,
  PUBLIC_BODY_TO_LINK_CLASS,
  PUBLIC_HEADING_ROW_GAP_CLASS,
} from "../Public/shared/publicLayoutSpec";

const BlogsData = [
  {
    link: "",
    blogName:
      "Blog Name list of service providers and select the best service on the basis of reviews",
    text: "Go select the best service on the basis of reviews. Go through the list of service providers and select the best service on the ",
  },
  {
    link: "",
    blogName:
      "Blog Name list of service and select the best service on the basis of reviews",
    text: "Go through the list of service providers select  of reviews. Go through the list of service providers and select select the best service on the basis of reviews. ",
  },
  {
    link: "",
    blogName:
      "Blog Name list of service and select the best service on the basis of reviews",
    text: "Go through the list of service providers and select of reviews. Go through the list of service ",
  },
  // {
  //   link: "",
  //   blogName:
  //     "Blog Name list of service providers and select the best service on the basis of reviews",
  //   text: "Go through the list of service providers and select the best service on the basis of reviews. select the best service on the basis of reviews. Go through the list of service providers and select the best service on the basis of reviews. select the best service on the basis of reviews.  ",
  // },
];
const BlogsDataMobile = [
  {
    link: "",
    blogName:
      "Blog Name list of service providers and select the best service on the basis of reviews",
    text: "Go select the best service on the basis of reviews. Go through the list of service providers and select the best service on the ",
  },
  {
    link: "",
    blogName:
      "Blog Name list of service and select the best service on the basis of reviews",
    text: "Go through the list of service providers select  of reviews. Go through the list of service providers and select select the best service on the basis of reviews. ",
  },
  {
    link: "",
    blogName:
      "Blog Name list of service and select the best service on the basis of reviews",
    text: "Go through the list of service providers and select of reviews. Go through the list of service ",
  },
  {
    link: "",
    blogName:
      "Blog Name list of service providers and select the best service on the basis of reviews",
    text: "Go through the list of service providers and select the best service on the basis of reviews. select the best service on the basis of reviews. Go through the list of service providers and select the best service on the basis of reviews. select the best service on the basis of reviews.  ",
  },
];

const Blogs = () => {
  // Ref for heading
  const headingRef = useRef(null);
  const isHeadingInView = useInView(headingRef, { once: true, amount: 1 });

  return (
    <>
      <div className={PUBLIC_SECTION_GAP_CLASS}>
        <div>
          <div className="tp-container-home mx-auto">
          {/* <motion.div
                  ref={headingRef}
                  initial={{ opacity: 0, y: 40 }}
                  animate={isHeadingInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
                  transition={{ duration: 1, ease: "easeOut" }}
                > */}
            <div className={`flex items-center justify-between ${PUBLIC_HEADING_ROW_GAP_CLASS}`}>
                <div>
                    <Heading variant={"h2"} className={"text-offblack"}>
                    Blog, Articles, and Updates
                    </Heading>
                </div>
                <div className="flex-shrink-0">
                  <Link to={`/blogs`}>
                    <MainButton variant={"small"}>Blog</MainButton>
                  </Link>
                </div>
            </div>
            {/* </motion.div> */}
          </div>
        </div>
        <div className="lg:hidden flex justify-center">
          <div className={`tp-container-home ${PUBLIC_HOME_BLOG_GRID_CLASS} ${PUBLIC_CARD_GRID_GAP_CLASS} mx-auto xl:w-fit text-ellipsis overflow-hidden sm:h-auto ${PUBLIC_HEADING_TO_CONTENT_CLASS}`}>
            {BlogsDataMobile.map((e, index) => {
              return (
                <BlogCard
                  link={e.link}
                  key={index}
                  blogName={e.blogName.split(/\s+/).slice(0, 9).join(" ")}
                  text={e.text}
                  blogTitle={e.blogTitle}
                  imageToTitleClassName={PUBLIC_IMAGE_TO_HEADING_CLASS}
                  titleToBodyClassName={PUBLIC_HEADING_TO_BODY_CLASS}
                  bodyToLinkClassName={PUBLIC_BODY_TO_LINK_CLASS}
                />
              );
            })}
          </div>
        </div>
        <div className="hidden lg:flex justify-center">
          <div className={`tp-container-home ${PUBLIC_HOME_BLOG_GRID_CLASS} ${PUBLIC_CARD_GRID_GAP_CLASS} mx-auto text-ellipsis overflow-hidden h-[550px] sm:h-auto ${PUBLIC_HEADING_TO_CONTENT_CLASS}`}>
            {BlogsData.map((e, index) => {
              return (
                <BlogCard
                  link={e.link}
                  key={index}
                  blogName={e.blogName.split(/\s+/).slice(0, 9).join(" ")}
                  text={e.text}
                  blogTitle={e.blogTitle}
                  imageToTitleClassName={PUBLIC_IMAGE_TO_HEADING_CLASS}
                  titleToBodyClassName={PUBLIC_HEADING_TO_BODY_CLASS}
                  bodyToLinkClassName={PUBLIC_BODY_TO_LINK_CLASS}
                />
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Blogs;
